import { ChangePasswordFormType } from 'data/Form/ChangePassword/types'
import { ForgotPasswordFormType } from 'data/Form/ForgotPassword/types'
import { PasswordStrengthErrorType } from 'data/Form/Signup/types'
import {
  change,
  ChangeAction,
  clearSubmitErrors,
  initialize,
  reset,
  stopAsyncValidation,
  stopSubmit,
  submit,
  SubmitAction
} from 'redux-form'

import * as AT from './actionTypes'

export type ValidatePasswordActionType = {
  payload: {
    form: string
    reject: (error: PasswordStrengthErrorType) => void
    resolve: (unkown?) => void
    values: ChangePasswordFormType | ForgotPasswordFormType
  }
  type: typeof AT.VALIDATE_PASSWORD
}

export type FormActionType = ChangeAction | SubmitAction | ValidatePasswordActionType

const validatePassword = (
  values: ChangePasswordFormType | ForgotPasswordFormType,
  resolve: (unkown?) => void,
  reject: (PasswordStrengthErrorType) => void,
  form: string
): ValidatePasswordActionType => ({
  payload: { form, reject, resolve, values },
  type: AT.VALIDATE_PASSWORD
})

export default {
  change,
  clearSubmitErrors,
  initialize,
  reset,
  stopAsyncValidation,
  stopSubmit,
  submit,
  validatePassword
}
